<h2 matDialogTitle>
    Details
    <button mat-icon-button class="close-button" [mat-dialog-close]="true" tabindex="-1">
        <mat-icon>close</mat-icon>
    </button>
</h2>
<mat-dialog-content class="mat-typography">
    @if (loading) {
        <mat-spinner></mat-spinner>
    }
    @if (!loading && !cacheEntry) {
        <div>Manifest not found</div>
    }
    <div class="links">
        <a class="link" mat-button [href]="gitUrl" target="_blank">GitLab
            <mat-icon>open_in_new</mat-icon>
        </a>
        <a class="link" mat-button [href]="ecbUrl" target="_blank">ECB
            <mat-icon>open_in_new</mat-icon>
        </a>
    </div>
    <div class="key">{{ data.cacheEntry.key }}</div>
    @if (cacheEntry) {
        <mat-tab-group>
            <mat-tab label="Version (Pretty Print)">
                @if (cacheEntry) {
                    <mat-accordion>
                        @for (version of cacheEntry.versions; track $index) {
                            <mat-expansion-panel [hideToggle]="true">
                                <mat-expansion-panel-header>
                                    <mat-panel-title> {{ version.date }} ({{ version.fileCount }}files)
                                    </mat-panel-title>
                                    <mat-panel-description> {{ version.key }}</mat-panel-description>
                                </mat-expansion-panel-header>
                                @for (file of version.files; track $index) {
                                    <div class="library-cache-entry-file">
                                        <div class="details">
                                            <div class="label">Path</div>
                                            <div class="value"><code>{{ file.path }}</code></div>
                                        </div>
                                        <div class="details">
                                            <div class="label">File</div>
                                            <div class="value">
                                                <a
                                                    target="_blank"
                                                    class="external"
                                                    [href]=getGitlabUrlForPath(file.path)>
                                                    View file on GitLab <mat-icon>open_in_new</mat-icon>
                                                </a>
                                            </div>
                                        </div>
                                        <div class="details">
                                            <div class="label">Hash</div>
                                            <div class="value">
                                                <code>{{ file.hash || "null" }}</code>
                                            </div>
                                        </div>
                                        <div class="details">
                                            <div class="label">Flags</div>
                                            <div class="value">
                                                <code><code>{{ file.flags.join() }}</code></code>
                                            </div>
                                        </div>
                                    </div>
                                    <hr>
                                }
                            </mat-expansion-panel>
                        }
                    </mat-accordion>
                }
            </mat-tab>
            <mat-tab label="Raw manifest">
                @if (cacheEntry) {
                    <pre>{{ cacheEntry.manifest | json }}</pre>
                }
            </mat-tab>
        </mat-tab-group>
    }
</mat-dialog-content>
